import { useEffect, useState } from 'react'
import { applyTrackingLocale } from '../config/i18n'
import http from '../helpers/http'
import useUUID from './useUUID'

type TrackingLoadError = {
  response?: {
    data?: {
      locale?: unknown
    }
  }
} | null

const useTrackingLoader = () => {
  const uuid = useUUID()
  const [data, setData] = useState<TTracking | null>(null)
  const [error, setError] = useState<TrackingLoadError>(null)
  const [loading, setLoading] = useState(false)
  const [loaded, setLoaded] = useState(false)

  const load = () => {
    setLoading(true)

    const url = `main-bff/api/public/${uuid}`

    http
      .get<TTracking>(url)
      .then(async (res) => {
        await applyTrackingLocale(res.data?.locale)
        setData(res.data)
      })
      .catch(async (err) => {
        const locale = err?.response?.data?.locale
        if (typeof locale === 'string') await applyTrackingLocale(locale)
        setError(err as TrackingLoadError)
      })
      .finally(() => {
        setLoading(false)
        setLoaded(true)
      })
  }

  useEffect(() => {
    if (!!uuid && !data && !loading && !loaded) load()
  }, [uuid, data, loading, loaded])

  return { data, error, loading, loaded, load }
}

export default useTrackingLoader
export { http }
